<template>
    <div class="indented margin-top-10">
        <div class="display-flex justify-content-space-between">
            <div class="wrap-left">
                <h6><strong>{{ item.name }}</strong></h6>
            </div>
            <div class="wrap-right display-flex justify-content-space-between">
                <button type="button" @click="handleAddDocument"
                    class="btn btn-main border-rd-20 font-size-16 form-30h display-flex-center justify-content-center line-height-1"
                    v-if="isEdit == 1">
                    Thêm bài giảng
                </button>
                <button type="button" @click="handleEditPost"
                    class="btn btn-edit border-rd-20 font-size-16 form-30h display-flex-center justify-content-center line-height-1"
                    v-if="isEdit == 1">
                    Sửa tên bài
                </button>
                <button type="button" @click="handleDeletePost"
                    class="btn btn-delete border-rd-20 font-size-16 form-30h display-flex-center justify-content-center line-height-1"
                    v-if="isEdit == 1">
                    Xóa bài
                </button>
            </div>
        </div>
        <slot name="document">
        </slot>
    </div>
</template>
<script>
export default {
    props: {
        item: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        },
        isEdit: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            isLoading: false
        }
    },
    methods: {
        handleAddDocument() {
            this.$emit('handleAddDocument', this.item)
        },
        handleEditPost() {
            this.$emit('handleEditPost', this.item)
        },
        handleDeletePost() {
            this.$emit('handleDeletePost', this.item)
        }
    }
}
</script>
<style lang="scss" scoped>
.btn-delete {
    background-color: red;
    color: white;
    margin-left: 5px;
}

.btn-edit {
    background-color: #7ea8c7;
    color: rgb(70, 69, 69);
    margin-left: 5px;
}

.margin-top-10 {
    margin-top: 10px;
}

.indented {
    margin-left: 20px;
    /* Đặt giá trị thụt cách tùy ý */
}

.justify-content-space-between {
    justify-content: space-between;
}
</style>